(function () {
  var video = document.getElementById('sphatik-scroll-video');
  if (!video) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    video.remove();
    document.body.classList.remove('has-sphatik-scroll-video');
    return;
  }

  var pageWrapper = document.querySelector('.page-wrapper');
  var duration = 0;
  var ticking = false;

  function onMetadataLoaded() {
    duration = video.duration;
  }

  video.addEventListener('loadedmetadata', onMetadataLoaded);
  if (video.readyState >= 1) {
    onMetadataLoaded();
  }

  // Horizon scrolls `.page-wrapper` internally on desktop (>=990px, html/body
  // are overflow:hidden there) but falls back to normal document scroll on
  // smaller viewports. Detect whichever is actually the live scroll container
  // right now, rather than hardcoding the breakpoint.
  function getScrollMetrics() {
    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
      return {
        pos: pageWrapper.scrollTop,
        max: pageWrapper.scrollHeight - pageWrapper.clientHeight,
      };
    }
    return {
      pos: window.scrollY,
      max: Math.max(document.documentElement.scrollHeight - window.innerHeight, 1),
    };
  }

  function updateVideoFrame() {
    ticking = false;

    if (!duration || !isFinite(duration)) {
      return;
    }

    var metrics = getScrollMetrics();
    var progress = metrics.max > 0 ? metrics.pos / metrics.max : 0;
    progress = Math.min(Math.max(progress, 0), 1);

    var targetTime = progress * duration;

    if (Math.abs(video.currentTime - targetTime) > 0.03) {
      try {
        video.currentTime = targetTime;
      } catch (e) {
        // Seeking can throw if the media isn't ready yet; safe to ignore and retry next frame.
      }
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateVideoFrame);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }

  onScroll();
})();
